import { validateInput, getErrorMsgAndCode } from "./FrontendHelpers";
import api from "./axios";

const checkInput = (ID, Name, Description) => {
  return validateInput([
    {
      Name: "ID",
      Value: ID,
      Type: "tagID",
      MaxLengthType: "id",
      MinLength: 1,
    },
    {
      Name: "Name",
      Value: Name,
      Type: "string",
      MinLength: 1,
      MaxLengthType: "name",
    },
    {
      Name: "Description",
      Value: Description,
      Type: "string",
      MaxLengthType: "detail",
      OnlyCheckLength: true,
      MinLength: 0,
    },
  ]);
};

export async function GetTags() {
  try {
    const response = await api.get("/getTags");
    const data = response.data;
    return [data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetTagMap(tags) {
  try {
    const map = new Map();
    tags.forEach((element) => {
      map.set(element.TagID, element.Name);
    });
    return [map, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetTagData(argument, bywhat = "TagID") {
  try {
    const data = { Argument: argument, byWhat: bywhat };
    const response = await api.post("/getTagInfo", data);
    const info = response.data;
    return [info[0], null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function CreateTag(ID, Name, Color, Description) {
  try {
    const validationError = checkInput(ID, Name, Description);
    if (validationError.errCode !== 0) return [null, validationError];

    const data = { ID, Name, Color, Description };

    const response = await api.post("/createTag", data);

    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

//Editing tags
export async function EditTag(ID, NewID, Name, Color, Description) {
  try {
    const validationError = checkInput(ID, Name);
    if (validationError.errCode !== 0) return [null, validationError];

    const data = { Name, ID: NewID, Color, Description, CurrentID: ID };

    const response = await api.post("/editTag", data);
    const data2 = response.data;
    return [data2, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

//Deleting tags
export async function DeleteTag(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/deleteTag", data);
    const data2 = response.data;
    return [data2, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetNextTagID() {
  try {
    const response = await api.get("/getNextTagID");
    const data = response.data;
    return [data.nextID, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
